import type { Application, PaymentPlan } from '@/api';

export const usePaymentPlanPolicy = (
    paymentPlan: Ref<PaymentPlan | undefined>,
    application?: Ref<Application | undefined>,
) => {
    const { company, user, permissions, isStudent, isAgency, isSchool } = useCompany();
    const getPolicy = (paymentPlan: PaymentPlan | undefined, application?: Application | undefined) => {
        const attempt = paymentPlan?.cancelled_at == null && (isAgency.value || isStudent.value);
        const cancel =
            isSchool.value &&
            (paymentPlan?.cancelled_at != null
                ? 'Payment Plan is already cancelled'
                : application != null && application.status !== 'confirmed'
                  ? 'Attach Confirmation of Enrolment first and finish the application process.'
                  : true);

        return {
            attempt,
            cancel,
        } as const;
    };

    const policy = computed(() => getPolicy(paymentPlan.value, application?.value));

    return { policy, getPolicy };
};
